<template>
  <div class="p_supply_module p_mems_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队名称</div>
                    <el-input v-model="listQuery.strConstrteamName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                  <div class="flname">姓名</div>
                  <el-input v-model="listQuery.strPerName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-loading="tableLoading">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="施工队员列表" name="first" v-if="checkPermission(['teamMembers_tab_list'],permissionLists)">
              <div class="r_act_box">
                <div class="r_act_left">
                  <div class="r_act_item" v-if="checkPermission(['teamMembers_add'],permissionLists)">
                    <el-button size="small" type="success" @click="addMemberHandle">新增队员</el-button>
                  </div>
                  <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['teamMembers_export'],permissionLists))">
                    <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
                  </div>
                </div>
              </div>
              <el-table ref="clueTable" class="re_table" border :header-cell-style="{background:'#f2f2f2',color: '#909399'}" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
                  <!-- <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
                    <template slot-scope="{$index}">
                        <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                      </template>
                  </el-table-column> -->
                  <template v-for="(item,index) in tableTitle">
                    <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('身份证号码')>-1||item.StrColumName.indexOf('公司名称')>-1||item.StrColumName.indexOf('证编号')>-1||item.StrColumName.indexOf('意外险保单号')>-1 ? '160px' : item.StrColumName.indexOf('实际施工')>-1||item.StrColumName.indexOf('注销次数')>-1||item.StrColumName.indexOf('意外险保单有效期')>-1||item.StrColumName.indexOf('时间')>-1?'160px':'110px'" align="center"
                      :fixed="item.StrColumName=='姓名'||item.StrColumName=='人员编号'">
                      <template slot-scope="{row}">
                        <p v-if="item.StrColumId=='StrConstrteamName'" class="auth_box">
                          <!-- <img src="./../../assets/images/auth.png" alt="" v-if="row.StrExamStatus=='已认证'"> -->
                          <span class="auth_title">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                        </p>
                        <el-badge value="NEW" class="new_icon" v-else-if="item.StrColumId=='StrPerName'&&isThreeDayHandle(row)">
                          <span>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                        </el-badge>
                        <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column align="center" label="操作" fixed="right" width="210px" class-name="re_act_box">
                    <template slot-scope="{row}">
                      <el-button v-if="checkPermission(['teamMembers_dtl'],permissionLists)" type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                      <el-button v-if="checkPermission(['teamMembers_edit'],permissionLists)" type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                      <el-button v-if="row.StrSerStatus!='退出'&&(checkPermission(['teamMembers_exit'],permissionLists))" type="info" size="mini" plain @click="exitHandle(row)">退出</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="listQuery.currpage"
                    :page-size="listQuery.perpage"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    layout="total,sizes,prev,pager,next,jumper"
                    :total="total"
                  ></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="checkPermission(['teamMembers_tab_remind'],permissionLists)" label="施工队员提醒" name="second"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <!-- 修改退出时间弹框 -->
    <el-dialog title="设置退出时间" :visible.sync="exitVisible" width="700px" class="res_dialog">
      <el-form :model="exitQuery" :rules="exitRules" ref="exitForm" class="re_dialog_form" label-width="130px">
        <el-form-item label="退出时间:" prop="DtexitDate">
            <el-date-picker size="small" value-format="yyyy-MM-dd" format='yyyy-MM-dd'
                  v-model="exitQuery.DtexitDate"
                  type="date"
                  placeholder="">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="strRemark">
            <el-input v-model="exitQuery.strRemark" type="textarea" size="small" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="exitVisible = false"
            size="small"
            >取消</el-button>
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveExitHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        downVisible:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'施工队员列表',
        activeName:'first',
        tableData: [],
        listQuery:{
          strConstrteamName:'',// 施工队名称
          strPerName:'',//  姓名
          strDutie:'',// 职务(人员分类)
          strArea:'',// 区域
          strCityCompany:'',// 城市公司
          currpage:1,
          perpage:10
        },
        // 退出规则
        exitRules: {
            DtexitDate: [
                { required: true, message: '请选择退出时间', trigger: 'change' }
            ]
        },
        exportQuery:{},
        btnLoading:false,
        // 表头参数
        titleQuery:{
          strTableId:'JB_busi_ConstrPerson', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        exitVisible:false,
        // 退出参数
        exitQuery:{
          GdupId:'',//标识
          DtexitDate:'',//退出时间
          strTableId:'JB_busi_ConstrPerson',//JB_busi_ConstrTeam 施工队 JB_busi_ConstrPerson施工队员
          strRemark:'' //备注
        },
        // 按钮权限参数
        butQuery:{
          path:'/teamMembers',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      this.getButtonPower()
      if(!this.isNull(this.$route.query.active)){
        this.activeName = this.$route.query.active
        // 表头
        this.getTableTitleLists()
      }
    },
    methods: {
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        checkPermission,
        // 获取按钮权限
        getButtonPower(){
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(this.checkPermission(['teamMembers_tab_list'],this.permissionLists)&&(this.isNull(this.$route.query.active))){
                  this.activeName = 'first'
                  // 表头
                  this.getTableTitleLists()
                }else if((!this.checkPermission(['teamMembers_tab_list'],this.permissionLists))&&(this.checkPermission(['teamMembers_tab_remind'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
                  this.$router.push({
                      path: '/teamReminder',
                      query:{
                          jumpname:'member',
                          active:'second'
                      }
                  })
                }
              }else{
                this.permissionLists = []
                this.activeName = ''
              }
            }else{
              this.permissionLists = []
              this.activeName = ''
            }
          })
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,this.titleQuery.strTableId).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 新增队员
        addMemberHandle(){
          this.$router.push({
            path: '/updateTeamMember'
          })
        },
        handleClick(tab, event) {
            // console.log(tab, event);
            this.activeName = tab.name
            this.$router.push({
              path: '/teamReminder',
              query: {
                jumpname: 'member',
                active: 'second'
              }
            })
        },
        // 编辑
        editHandle(row){
          // console.log('row',row)
          this.$router.push({
            path: '/updateTeamMember',
            query: {
              id: row.GdteamperId
            }
          })
        },
        // 退出
        exitHandle(row){
          this.exitVisible = true
          this.exitQuery.GdupId = row.GdteamperId
          this.exitQuery.DtexitDate = ''
          this.exitQuery.strRemark = ''
        },
        // 保存修改退出时间
        saveExitHandle(){
          this.$refs['exitForm'].validate((valid) => {
            if (valid) {
              xz.saveConstrDtexitDate(this.exitQuery).then(res => {
                if (res.status == 'ok') {
                  this.$message({ type: 'success', message: '操作成功' })
                  this.getList()
                  this.exitVisible = false
                }else{
                  this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
              })
            } else {
              return false;
            }
          })
        },
        // 详情
        dtlHandle(row){
          let routeUrl = this.$router.resolve(
            { path: '/teamMemberDetail',query:{
              id: row.GdteamperId
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            // console.log('33',res)
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getConstrTeamPersonLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.tableData = res.msg
                  this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
            this.listQuery = this.$options.data.call(this).listQuery
        },
        // 判断更新时间是否在三天内
        isThreeDayHandle(row){
          // 当前时间前三天
          let beforeDay = moment().subtract(3, "days").format("YYYY-MM-DD HH:mm")
          let date = moment(row.DtInsertDate).format("YYYY-MM-DD HH:mm")
          // console.log(1111,beforeDay,date)
          return (new Date(beforeDay).getTime()<new Date(date).getTime())&&(new Date().getTime()>new Date(date).getTime())
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.auth_box{
  display: flex;
  align-items: center;
}
.auth_title{
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.auth_box img{
  width: 20px;
  height: 20px;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_mems_module .el-table__row .el-table__cell:nth-child(2) .cell{
  overflow: visible;
}
.p_mems_module .el-tabs__header{
  margin-bottom: 0;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 6px 0;
}
</style>